import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach token if available (Bearer fallback for the iframe / preview env)
api.interceptors.request.use((cfg) => {
  const token = typeof window !== "undefined" ? localStorage.getItem("equinox_token") : null;
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

export function formatErr(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (d && typeof d === "object" && d.msg) return d.msg;
  return err?.message || "Something went wrong";
}

export const fmtMoney = (n, opts = {}) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0, ...opts }).format(n || 0);

export const fmtDate = (s) => {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return "—";
  }
};

export const fmtDateRelative = (s) => {
  if (!s) return "—";
  const diff = (new Date(s) - new Date()) / (1000 * 60 * 60 * 24);
  const d = Math.round(diff);
  if (d === 0) return "Today";
  if (d === 1) return "Tomorrow";
  if (d === -1) return "Yesterday";
  if (d > 0) return `In ${d} days`;
  return `${Math.abs(d)} days ago`;
};

export const STAGES = [
  { id: "lead", label: "Lead", accent: "from-slate-400 to-slate-500" },
  { id: "discovery", label: "Discovery", accent: "from-sky-400 to-sky-500" },
  { id: "proposal", label: "Proposal", accent: "from-indigo-400 to-indigo-500" },
  { id: "follow_up", label: "Follow Up", accent: "from-amber-400 to-amber-500" },
  { id: "won", label: "Won", accent: "from-emerald-400 to-emerald-500" },
  { id: "development", label: "Development", accent: "from-blue-400 to-blue-500" },
  { id: "review", label: "Review", accent: "from-violet-400 to-violet-500" },
  { id: "deployed", label: "Deployed", accent: "from-cyan-400 to-cyan-500" },
  { id: "closed", label: "Closed", accent: "from-teal-400 to-teal-500" },
  { id: "lost", label: "Lost", accent: "from-rose-400 to-rose-500" },
];

export const STAGE_BY_ID = Object.fromEntries(STAGES.map((s) => [s.id, s]));
